import boostOddsOfAnOffer from '@backrs_ui/grow-ui/src/assets/images/sessionBanners/boost_odds_of_an_offer.png';
import boostYourProfile from '@backrs_ui/grow-ui/src/assets/images/sessionBanners/boost_your_profile.png';
import collegeShortlist from '@backrs_ui/grow-ui/src/assets/images/sessionBanners/college_shortlist.png';
import essayIdeas from '@backrs_ui/grow-ui/src/assets/images/sessionBanners/essay_ideas.png';
import improveYourTestScores from '@backrs_ui/grow-ui/src/assets/images/sessionBanners/improve_your_test_scores.png';
import jobsYouMightLove from '@backrs_ui/grow-ui/src/assets/images/sessionBanners/jobs_you_might_love.png';
import lowerCostOfCollege from '@backrs_ui/grow-ui/src/assets/images/sessionBanners/lower_cost_of_college.png';
import majors from '@backrs_ui/grow-ui/src/assets/images/sessionBanners/majors.png';
import resumeOptimizer from '@backrs_ui/grow-ui/src/assets/images/sessionBanners/resume_optimizer.png';
import whatAreYourChances from '@backrs_ui/grow-ui/src/assets/images/sessionBanners/what_are_your_chances.png';
import {
  type LubavSessionType,
  OFFICE_HOURS_SESSION_IDS,
  type StructuredSessionId,
} from '@backrs_ui/grow-ui/src/models/models';
import { useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';
import {
  getDisplayedSession,
  getPreviewedSession,
} from '@backrs_ui/grow-ui/src/redux/lubavSessionState/lubavSessionState.utils';
import { selectIsSharedSessionActive } from '@backrs_ui/grow-ui/src/redux/sharedSession/sharedSession';

import { Box, SxProps, Theme } from '@mui/material';

import { StructuredSessionActionButtons } from './StructuredSessionActionButtons';

const SESSION_BANNERS: Partial<Record<StructuredSessionId, string>> = {
  [OFFICE_HOURS_SESSION_IDS.BOOST_ODDS_OF_AN_OFFER]: boostOddsOfAnOffer,
  [OFFICE_HOURS_SESSION_IDS.BOOST_YOUR_PROFILE]: boostYourProfile,
  [OFFICE_HOURS_SESSION_IDS.COLLEGE_SHORTLIST]: collegeShortlist,
  [OFFICE_HOURS_SESSION_IDS.ESSAY_IDEAS]: essayIdeas,
  [OFFICE_HOURS_SESSION_IDS.IMPROVE_YOUR_TEST_SCORES]: improveYourTestScores,
  [OFFICE_HOURS_SESSION_IDS.JOBS_YOU_MIGHT_LOVE]: jobsYouMightLove,
  [OFFICE_HOURS_SESSION_IDS.LOWER_COST_OF_COLLEGE]: lowerCostOfCollege,
  [OFFICE_HOURS_SESSION_IDS.MAJORS]: majors,
  [OFFICE_HOURS_SESSION_IDS.RESUME_OPTIMIZER]: resumeOptimizer,
  [OFFICE_HOURS_SESSION_IDS.WHAT_ARE_YOUR_CHANCES]: whatAreYourChances,
};

export const getSessionBanner = (session: LubavSessionType | null): string | undefined =>
  session ? SESSION_BANNERS[session as StructuredSessionId] : undefined;

export const SessionBanner = () => {
  const displayedSession = useAppSelector(getDisplayedSession);
  const previewedSession = useAppSelector(getPreviewedSession);
  const isSharedSession = useAppSelector(selectIsSharedSessionActive);
  const banner = getSessionBanner(displayedSession);

  if (!banner) {
    return null;
  }

  const showActions = !isSharedSession && !previewedSession;

  return (
    <Box sx={containerSx}>
      <Box className="session-banner" sx={cardSx}>
        <Box component="img" src={banner} alt="" sx={imageSx} />
        {showActions && (
          <Box sx={actionsSx}>
            <StructuredSessionActionButtons />
          </Box>
        )}
      </Box>
    </Box>
  );
};

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  flexShrink: 0,
  pr: backrs.spacing['spacing-md'],
  pl: {
    xs: backrs.spacing['spacing-md'],
    md: 0,
  },
  pb: backrs.spacing['spacing-lg'],
});

const cardSx: SxProps<Theme> = ({ backrs }) => ({
  position: 'relative',
  width: '100%',
  overflow: 'hidden',
  borderRadius: backrs.radius['radius-xl'],
  border: `1px solid ${backrs.colors['Colors/Base/Black']}`,
  backgroundColor: backrs.colors['Brand/50'],
});

const imageSx: SxProps<Theme> = {
  display: 'block',
  width: '100%',
  maxHeight: 180,
  height: 'auto',
  objectFit: 'contain',
  objectPosition: 'center',
};

const actionsSx: SxProps<Theme> = ({ backrs }) => ({
  position: 'absolute',
  top: backrs.spacing['spacing-lg'],
  right: backrs.spacing['spacing-lg'],
  opacity: 0,
  visibility: 'hidden',
  transition: 'opacity 0.2s ease-in-out, visibility 0.2s ease-in-out',
  '.session-banner:hover &, .session-banner:focus-within &': {
    opacity: 1,
    visibility: 'visible',
  },
  '@media (hover: none), (max-width: 900px)': {
    opacity: 1,
    visibility: 'visible',
  },
});
